import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
export const banner = tailwindVariants({
    base: "flex gap-2 rounded",
    variants: {
        appearance: {
            danger: "bg-red-3 text-red-11",
            info: "bg-blue-2 text-blue-12",
            quiet: "bg-grey-3 text-grey-12",
            success: "bg-teal-5 text-blue-12",
            warning: "bg-yellow-2 text-yellow-12"
        },
        size: {
            small: "p-2 text-14",
            medium: "p-4 text-14"
        }
    },
    defaultVariants: {
        appearance: "quiet",
        size: "medium"
    }
});
export const Banner = (param)=>{
    let { appearance, children, className, prefix, size, suffix, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: banner({
            appearance,
            size,
            class: className
        }),
        "data-testid": "BANNER",
        role: "alert",
        ...restOfProps,
        children: [
            prefix ? /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: prefix
            }) : null,
            /*#__PURE__*/ _jsx("div", {
                className: "grow",
                children: children
            }),
            suffix ? /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: suffix
            }) : null
        ]
    });
};
